import { Autocomplete, TextField } from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme, isDarkTheme } from '~/redux/features'
import { EFAutocompleteProps } from './EFAutoComplete.model'
import { EFInputLabel } from '../EFInputLabel'
import classNames from 'classnames/bind'
import styles from './EFAutoComplete.module.scss'

const cx = classNames.bind(styles)

export function EFAutocomplete(props: EFAutocompleteProps) {
  const { label, data, value, onChange } = props
  const theme = useAppSelector(currentTheme)
  const isDark = useAppSelector(isDarkTheme)
  const defaultValues = data.filter(item => value?.includes(item.value) ?? data[0])

  return (
    <div className='custom-field'>
      {label && (
        <EFInputLabel
          name={props.name}
          label={label}
        />
      )}
      <Autocomplete
        onChange={(_event: any, value) => onChange && onChange(value)}
        multiple
        filterSelectedOptions
        options={data}
        getOptionLabel={option => option.name}
        value={defaultValues}
        ListboxProps={{ className: `theme-background ${theme}` }}
        ChipProps={{
          sx: isDark
            ? {
                backgroundColor: 'rgb(255 255 255 / 8%)',
                color: 'var(--white)',
                '& .MuiChip-deleteIcon': { color: 'rgb(255 255 255 / 26%) !important' }
              }
            : {}
        }}
        renderInput={params => (
          <TextField
            {...params}
            variant='outlined'
            label={props.label}
            placeholder={props.placeholder}
            InputLabelProps={{ style: { display: 'none' }, shrink: false }}
            className={cx('text-field', theme)}
          />
        )}
      />
    </div>
  )
}
